import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { EmployerResource } from './Employer';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class HiringHeroMetricAttributes {
  createdAt: string = null;
  updatedAt: string = null;
  metricType: string = null;
  criteria: number = null;
  current: number = null;
  total: number = null;
  percentage: number = null;
  met: boolean = false;
  employerId: string = null;
}

export class HiringHeroMetricBelongsTo {
  employer: () => EmployerResource = () => new EmployerResource();
}

export class HiringHeroMetricHasOne {}

export class HiringHeroMetricHasMany {}

/**
 * Utility interfaces
 */
export interface HiringHeroMetricMethods {}

export interface HiringHeroMetricInterface
  extends HiringHeroMetricAttributes,
    HiringHeroMetricBelongsTo,
    HiringHeroMetricHasOne,
    HiringHeroMetricHasMany,
    HiringHeroMetricType {}

type HiringHeroMetricType = GConstructor<HiringHeroMetricInterface>;

export interface HiringHeroMetricResource
  extends Base<HiringHeroMetricAttributes>,
    HiringHeroMetricInterface,
    HiringHeroMetricMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<HiringHeroMetricAttributes>({
    queryName: 'metrics',
    className: 'HiringHeroMetric',
    AttributesClass: HiringHeroMetricAttributes,
    BelongsToClasses: [
      {
        Klass: HiringHeroMetricBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: HiringHeroMetricHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: HiringHeroMetricHasMany,
      },
    ],
  });

export const HiringHeroMetricResourceClass = <TBase extends HiringHeroMetricType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements HiringHeroMetricMethods {};

export class HiringHeroMetricResource extends ClassExtender<HiringHeroMetricInterface>(
  BaseClass,
  HiringHeroMetricResourceClass,
) {}

/**
 * Resource instance
 */
export const HiringHeroMetric =
  APILibrary.createResource<HiringHeroMetricResource>(HiringHeroMetricResource);
